import { createRoot } from "react-dom/client";
import { HeroSalesSection } from "@/app/components/HeroSalesSection";
import { ProblemSection } from "@/app/components/ProblemSection";
import { DashboardSection } from "@/app/components/DashboardSection";
import { IdentitySection } from "@/app/components/IdentitySection";
import { RevenueRecoverySection } from "@/app/components/RevenueRecoverySection";
import { PerformanceSection } from "@/app/components/PerformanceSection";
import { SocialProofSection } from "@/app/components/SocialProofSection";
import { OfferSection } from "@/app/components/OfferSection";
import { FAQSection } from "@/app/components/FAQSection";
import { Navigation } from "@/app/components/Navigation";
import { Footer } from "@/app/components/Footer";
import "@/styles/index.css";

function SalesPage() {
  return (
    <div className="relative bg-[#0B0E14] overflow-x-hidden">
      <Navigation />
      <HeroSalesSection />
      <div id="problema"><ProblemSection /></div>
      <div id="dashboard"><DashboardSection /></div>
      <div id="identidade"><IdentitySection /></div>
      <div id="roi"><RevenueRecoverySection /></div>
      <div id="performance"><PerformanceSection /></div>
      <SocialProofSection />
      <OfferSection />
      <FAQSection />
      <Footer />
    </div>
  );
}

createRoot(document.getElementById("root")!).render(<SalesPage />);
